export default function parseNote(note) {
  if (typeof note !== "string" || !note.trim()) {
    return "";
  }

  try {
    const parsedNote = JSON.parse(note);

    return Object.values(parsedNote)
      .flatMap(item => Object.values(item))
      .join(" \n ");
  } catch (error) {
    return note;
  }
}
